


































import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
  },
})
export default class SimplePagination extends Vue {
  @Prop(Number) from!: number;
  @Prop(Number) to!: number;
  @Prop(Number) totalItem!: number;
  @Prop(Boolean) loading!: boolean;
  @Prop(Boolean) hasNext!: boolean;
  @Prop(Boolean) hasPrev!: boolean;
  @Prop(Function) next!: () => {};
  @Prop(Function) prev!: () => {};
}
